// extracted by mini-css-extract-plugin
export default {"container":"_1MW2K","content":"WBjJ8"};